import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { hideModal, MODAL_TYPE_PRO_MYPAGE_REVIEW, } from '../../../../../actions/ModalActions';
import { API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_REVIEW, apiUpdateProfessionalSolutionOrderReview, } from '../../../../../actions/ProfessionalMySolutionActions';
import { propBool, propFunc, propShape, } from '../../../../../helpers/custom-prop-types';
import { isLoadingApis } from '../../../../../helpers/fetch';
import { getModalValue } from '../../../../../helpers/modal';
import Modal from '../../../../Ui/Modal';
import FormProfessionalReview from '../Form/FormProfessionaReview';
const ModalReview = ({ handleSubmit, isLoadingApi, order, solution }) => (_jsx(Modal, Object.assign({ isLoading: isLoadingApi, modalType: MODAL_TYPE_PRO_MYPAGE_REVIEW }, { children: _jsx(FormProfessionalReview, { disabled: !!order.review, enableReinitialize: true, initialValues: Object.assign({ overRequest: 3, rate: 3, rerunSolution: 3, startSolution: 3 }, (order.review ? order.review : {})), isLoadingApi: isLoadingApi, onSubmit: (values) => handleSubmit(order, values), solution: solution }) })));
ModalReview.propTypes = {
    handleSubmit: propFunc().isRequired,
    isLoadingApi: propBool().isRequired,
    order: propShape().isRequired,
    solution: propShape().isRequired,
};
const mapStateToProps = ({ fetch, modal }) => {
    const { item: { order, solution }, } = getModalValue(modal, MODAL_TYPE_PRO_MYPAGE_REVIEW);
    return {
        isLoadingApi: isLoadingApis(fetch, API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_REVIEW),
        order,
        solution,
    };
};
const mapDispatchToProps = (dispatch) => ({
    handleSubmit: (order, data) => {
        dispatch(apiUpdateProfessionalSolutionOrderReview(order.id, data, {
            meta: 'FormProfessionalReview',
            resolve: hideModal(MODAL_TYPE_PRO_MYPAGE_REVIEW),
        }));
    },
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
export default enhance(ModalReview);
